import { Controller } from "@hotwired/stimulus"

// Polls the republish status endpoint and drives the progress bar on the
// admin settings Recipe Republish card.
export default class extends Controller {
  static targets = [
    "progressSection",
    "progressBar",
    "progressLabel",
    "statusBadge",
    "republishBtn",
    "errorCount"
  ]

  static values = {
    statusUrl: String,
    pollInterval: { type: Number, default: 2500 }
  }

  connect() {
    this.fetchStatus()
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  // Private

  fetchStatus() {
    fetch(this.statusUrlValue, {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    })
      .then(response => {
        if (!response.ok) {
          console.error(`[RecipeRepublish] Status fetch failed: HTTP ${response.status}`)
          return null
        }
        return response.json()
      })
      .then(data => { if (data) this.applyStatus(data) })
      .catch(err => console.error("[RecipeRepublish] Fetch error:", err))
  }

  startPolling() {
    if (this._pollTimer) return
    this._pollTimer = setInterval(() => this.fetchStatus(), this.pollIntervalValue)
  }

  stopPolling() {
    if (this._pollTimer) {
      clearInterval(this._pollTimer)
      this._pollTimer = null
    }
  }

  applyStatus(data) {
    const { status, total, completed, errors } = data

    if (status === 'idle') {
      this.progressSectionTarget.classList.add('d-none')
      this.stopPolling()
      return
    }

    this.progressSectionTarget.classList.remove('d-none')

    const pct = total > 0 ? Math.round((completed / total) * 100) : 0

    this.progressBarTarget.style.width = `${pct}%`
    this.progressBarTarget.setAttribute('aria-valuenow', pct)
    this.progressBarTarget.textContent = `${pct}%`

    if (status === 'running') {
      this.progressBarTarget.classList.remove('bg-success')
      this.progressBarTarget.classList.add('progress-bar-striped', 'progress-bar-animated')
      this.progressLabelTarget.textContent = `Syncing… ${completed} of ${total} articles`
      this.statusBadgeTarget.className = 'badge bg-warning text-dark ms-2'
      this.statusBadgeTarget.textContent = 'Running'
      this.republishBtnTarget.disabled = true
      this.republishBtnTarget.innerHTML = 'Running…'
    } else if (status === 'completed') {
      this.progressBarTarget.classList.remove('progress-bar-striped', 'progress-bar-animated')
      this.progressBarTarget.classList.add('bg-success')
      this.progressBarTarget.style.width = '100%'
      this.progressBarTarget.textContent = '100%'
      this.progressLabelTarget.textContent = `Complete — ${completed} of ${total} articles synced`
      this.statusBadgeTarget.className = 'badge bg-success ms-2'
      this.statusBadgeTarget.textContent = 'Done'
      this.republishBtnTarget.disabled = false
      this.republishBtnTarget.innerHTML = '<i class="bi bi-arrow-repeat me-1"></i> Republish All'
      this.stopPolling()
    }

    if (errors > 0) {
      this.errorCountTarget.textContent = `${errors} error${errors !== 1 ? 's' : ''}`
      this.errorCountTarget.classList.remove('d-none')
    } else {
      this.errorCountTarget.classList.add('d-none')
    }
  }
}
